import Vue from 'vue'

const Mixin = {
    methods: {
        getHello() {
            return "Hello!"
        },
        typeAnimation(text, callback){
            var string = text, j = 0,
                intervalHolder = setInterval(function(){
                    $('.type-animation').text(string.substring(0, j++));
                    if(j > string.length){
                        clearInterval(intervalHolder);
                        if(typeof callback == 'function') callback();
                    }
                }, 50);
        },
        getCookie(cname) {
            
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        setCookie(cname, cvalue, exdays, path) {
            path = path || "/";
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path;
        },
        checkCookie(view) {
            if (!this.getCookie('animated-noindex') && view == 'nfp') {
                //console.log('podstrona')
                new Vivus('title_paths', {
                    type: 'delayed',
                    duration: 120,
                    onReady: function() {
                        setTimeout(function() {
                            $('#header_shape rect').addClass('filled');
                        }, 50);
                    },
                    animTimingFunction: Vivus.EASE,
                }, function() {
                    $('#title_paths').addClass('filled');
                });
                new Vivus('hamburger', {
                    type: 'delayed',
                    duration: 120,
                    animTimingFunction: Vivus.EASE,
                });
                new Vivus('search', {
                    type: 'sync',
                    duration: 120,
                    animTimingFunction: Vivus.EASE,
                });
                this.setCookie('animated-noindex', 'true', 1);
            }

            if (!this.getCookie('animated-fp') && view == 'fp') {
            //if (true) {
                setTimeout(function() {
                    $('.search-form').addClass('shown');
                }, 50);


                let self = this
                //console.log('strona glowna')
                // error przy index i back button
                new Vivus('title_paths', {
                    type: 'delayed',
                    duration: 120,
                    onReady: function() {
                        setTimeout(function() {
                            $('#header_shape rect').addClass('filled');
                        }, 50);
                    },
                    animTimingFunction: Vivus.EASE,
                }, function() {
                    $('#title_paths').addClass('filled');
                    uw.play(1);
                });
                var uw = new Vivus('uw_100', {
                    type: 'sync',
                    start: 'manual',
                    duration: 120,
                    animTimingFunction: Vivus.EASE,
                }, function() {
                    bBox.play(0.2);
                    bBox3.play(0.2);
                    // $('#uw_100').addClass('filled');
                    // let txt = $(".slogan-content").text();
                    // console.log($(".slogan-content").text());
                    // self.typeAnimation(txt, function() {
                    //     //$('.search-form').addClass('shown');
                    //     //$('.b-box2').addClass('filled');
                    //     setTimeout(function() {
                    //         bBox.play(0.2);
                    //         bBox3.play(0.2);
                    //     }, 30);
                    // });
                });
                new Vivus('hamburger', {
                    type: 'delayed',
                    duration: 30,
                    animTimingFunction: Vivus.EASE,
                }, function() {

                });
                var bBox = new Vivus('b-box1', {
                    type: 'sync',
                    duration: 30,
                    //start: 'manual',
                    animTimingFunction: Vivus.EASE,
                });
                //bBox.play();
                var bBox3 = new Vivus('b-box3', {
                    type: 'sync',
                    duration: 30,
                    animTimingFunction: Vivus.EASE,
                }, function(){
                    $('#b-box4').addClass('filled');
                });
                new Vivus('b-box2', {
                    type: 'sync',
                    start: 'autostart',
                    duration: 30,
                    animTimingFunction: Vivus.EASE,
                }, function() {
                    $('#b-box2').addClass('filled');
                    $('.biograms .img-link, .biograms .text-wrapper').addClass('shown');
                    $('.showpieces .img-link, .showpieces .text-wrapper').addClass('shown');
                    setTimeout(function() {
                        siatka.play(1);
                    }, 120);
                });
                var siatka = new Vivus('siatka', {
                    type: 'sync',
                    start: 'manual',
                    duration: 30,
                    animTimingFunction: Vivus.EASE,
                }, function() {});
                new Vivus('blur_rect', {
                    type: 'scenario',
                    duration: 10,
                    animTimingFunction: Vivus.EASE,
                }, function() {
                    $('.photographs #blur_rect, .photographs .img-link, .photographs .text-wrapper').addClass('shown');
                    $('.recordings #blur_rect, .recordings .img-link, .recordings .text-wrapper').addClass('shown');
                });
                new Vivus('doc-lines', {
                    type: 'oneByOne',
                    duration: 30,
                    animTimingFunction: Vivus.EASE,
                }, function() {
                    $('.documents .img-link, .documents .text-wrapper').addClass('shown');
                    $('.photographs #blur_rect, .photographs .img-link, .photographs .text-wrapper').addClass('shown');
                    self.setCookie('animated-fp', 'true', 1);
                });
            }

        },
        toggleBodyId(addRemoveId, idName) {
            const el = document.body;

            if (addRemoveId === 'addId') {
                el.id = idName
            } else {
                el.removeAttribute('id')
            }
        },
        typeAnimation(text, callback) {
            var string = text,
                j = 0,
                intervalHolder = setInterval(function() {
                    $('.type-animation').text(string.substring(0, j++));
                    if (j > string.length) {
                        clearInterval(intervalHolder);
                        if (typeof callback == 'function') callback();
                    }
                }, 50);
        },
        checkAnimation() {
            if (this.getCookie('animated-fp')) {
                // nie wyswietlaj
                return false
            }
            // wyswietl
            return true
        },
        polishPlurals(singularNominativ, pluralNominativ, pluralGenitive, value) {

            // @https://github.com/mmiszy/polish-plurals

            if (value === 1) {
                return singularNominativ;
            } else if (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20)) {
                return pluralNominativ;
            } else {
                return pluralGenitive;
            }
        },
        // background @grids
        load() {
            var img = $('.photographs .img-wrapper img'),
                w = img.width(),
                h = img.height();

            if ($('.results-wrapper').length) {
                if (window.innerWidth > 768) {
                    var lastRight = 0;
                    var rows = 0;
                    var bodyP = $('body>.container').offset().left;

                    $('.results-wrapper img').each(function(i) {
                        var top = $(this).offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight(),
                            left = $(this).offset().left - bodyP,
                            w = $(this).width(),
                            h = $(this).height(),
                            mBW = 200; // max box width

                        if (lastRight != 0) {
                            lastRight += (Math.random() * 20) + 10;
                            var boxSize = left - lastRight - (Math.random() * 30) - 10;
                        } else {
                            var boxSize = left - (Math.random() * 40) - 5;
                        }

                        if (boxSize > mBW) {
                            var boxCount = Math.ceil(boxSize / mBW),
                                gutter; // next box gutter

                            for (var i = 0; i < boxCount; i++) {
                                var boxSizePart = mBW - (Math.random() * 30) - 10;

                                if (boxSize > boxSizePart) {
                                    gutter = (Math.random() * 30) + 5;
                                    boxSize -= boxSizePart + gutter;
                                } else {
                                    boxSizePart = boxSize;
                                }

                                $('.box-wrapper').append('<div class="box"></div>');
                                $('.box-wrapper>.box').last().css({
                                    top: top,
                                    left: lastRight,
                                    width: boxSizePart,
                                    height: h,
                                });

                                lastRight += boxSizePart + gutter;
                            }
                        } else {
                            $('.box-wrapper').append('<div class="box"></div>');
                            $('.box-wrapper>.box').last().css({
                                top: top,
                                left: lastRight,
                                width: boxSize,
                                height: h,
                            });
                        }

                        if (i % 3 == 0) {
                            rows++;
                        };

                        lastRight = i % 3 == 2 ? 0 : left + w;
                    });

                    for (var row = 0; row < rows; row++) { // rects most on right
                        var item = $('.results-wrapper img').eq(row * 3 + 2);

                        if (!item.length) {
                            item = $('.results-wrapper img').last();
                        }

                        var top = item.offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight(),
                            left = item.offset().left - bodyP,
                            w = item.width(),
                            h = item.height(),
                            position = left + w + (Math.random() * 20) + 10;

                        $('.last-column').append('<div class="box"></div>');
                        $('.last-column>.box').last().css({
                            top: top,
                            left: position,
                            width: window.innerWidth - position - 15,
                            height: h,
                        });
                    }
                } else {
                    $('.results-wrapper img').each(function(i) {
                        var top = $(this).offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight(),
                            left = $(this).offset().left,
                            w = $(this).width(),
                            h = $(this).height(),
                            randomFactor = window.innerWidth > 480 ? Math.random() * 20 : Math.random() * 5;

                        var boxSize = left - randomFactor - 5;

                        $('.box-wrapper').append('<div class="box"></div>');
                        $('.box-wrapper>.box').last().css({
                            top: top,
                            left: 0,
                            width: boxSize,
                            height: h,
                        });

                        var randomFactor = window.innerWidth > 480 ? Math.random() * 20 : Math.random() * 5,
                            boxSize = window.innerWidth - left - w - randomFactor - 5;

                        $('.last-column').append('<div class="box"></div>');
                        $('.last-column>.box').last().css({
                            top: top,
                            width: boxSize,
                            height: h,
                        });
                    });
                }
            }

            if ($('.single-biogram').length && window.innerWidth > 768) {
                var bodyP = $('body>.container').offset().left;
                var lastRight = 0;

                $('.related-item img').each(function(i) {
                    var top = $(this).offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight() - $('.col-2').innerHeight(),
                        left = $(this).offset().left - bodyP,
                        w = $(this).width(),
                        h = $(this).height(),
                        mBW = 200; // max box width

                    if (lastRight != 0) {
                        lastRight += (Math.random() * 20) + 10;
                        var boxSize = left - lastRight - (Math.random() * 30);

                        if (i == 1) boxSize -= 15;
                    } else {
                        var boxSize = left - (Math.random() * 30) - 5;
                    }

                    if (boxSize > mBW) {
                        var boxCount = Math.ceil(boxSize / mBW);

                        for (var i = 0; i < boxCount; i++) {
                            var boxSizePart = mBW - (Math.random() * 30) - 10,
                                gutter; // next box gutter

                            if (boxSize > boxSizePart) {
                                boxSize -= boxSizePart;
                                gutter = (Math.random() * 15) + 10;
                            } else {
                                boxSizePart = boxSize - gutter;
                                gutter = 0;
                            }

                            $('.box-wrapper').append('<div class="box"></div>');
                            $('.box-wrapper>.box').last().css({
                                top: top,
                                left: lastRight,
                                width: boxSizePart,
                                height: h,
                            });

                            lastRight += boxSizePart + gutter;
                        }
                    } else {
                        $('.box-wrapper').append('<div class="box"></div>');
                        $('.box-wrapper>.box').last().css({
                            top: top,
                            left: lastRight,
                            width: boxSize,
                            height: h,
                        });
                    }
                    lastRight = left + w;
                });

                var item = $('.related-item img').eq(2);
                var top = item.offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight() - $('.col-2').innerHeight(),
                    left = item.offset().left - bodyP,
                    w = item.width(),
                    h = item.height();

                $('.box-wrapper').append('<div class="box"></div>');
                $('.box-wrapper>.box').last().css({
                    top: top,
                    left: 'auto',
                    right: 0,
                    width: w - (Math.random() * 10) - 60,
                    height: h,
                });
            }
        }

    }
}

export default {
    install(Vue, options) {
        Vue.mixin(Mixin)
    }
}


// WEBPACK FOOTER //
// ./src/functions.js